import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { TextField, Button, Container, IconButton, Backdrop, CircularProgress, CssBaseline } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const ResetPassword = ({ toggleColorMode }) => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [themeMode, setThemeMode] = useState('dark');

  // Redirect if email is not available in state
  if (!state || !state.email) {
    navigate('/forgot-password');
  }

  const { email } = state;

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    // Check if new password and confirm password match
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match!');
      setLoading(false);
      return;
    }

    try {
      const response = await axios.post('https://api.dmaverix.com/api/v2/auth/password/v-otp/reset', {
        otpToken: otp,
        email,
        newPassword,
      });

      if (response.data.success) {
        setMessage('Password reset successfully!');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setMessage('Error resetting password. Please try again.');
      }
    } catch (error) {
      setMessage('An error occurred while resetting the password.');
    } finally {
      setLoading(false);
    }
  };
useEffect(() => {
        const savedThemeMode = localStorage.getItem('themeMode') || 'dark';
        setThemeMode(savedThemeMode);
    }, []);
  // Toggle theme between dark and light
  const toggleTheme = () => {
    const newMode = themeMode === 'dark' ? 'light' : 'dark';
    setThemeMode(newMode);
    localStorage.setItem('themeMode', newMode);

  };

  // Define theme
  const theme = createTheme({
    palette: {
      mode: themeMode,
      primary: {
        main: themeMode === 'light' ? '#6200ea' : '#bb86fc',
      },
      background: {
        default: themeMode === 'light' ? '#f5f5f5' : '#121212',
        paper: themeMode === 'light' ? '#ffffff' : '#333333',
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="xs" style={{ paddingTop: '50px', position: 'relative' }}>
        <Backdrop open={loading} style={{ color: '#fff', zIndex: 1 }}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <div style={{
          background: themeMode === 'light' ? '#ffffff' : '#333333',
          padding: '30px',
          borderRadius: '15px',
          boxShadow: '0 8px 32px rgba(31, 38, 135, 0.37)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <h2 style={{ color: themeMode === 'light' ? '#333' : '#fff' }}>Reset Password</h2>
          {message && (
            <p style={{ color: message.includes('successfully') ? 'green' : 'red', fontSize: '14px' }}>
              {message}
            </p>
          )}

          <form onSubmit={handleSubmit} style={{ width: '100%' }}>
            <TextField
              label="OTP"
              type="text"
              variant="outlined"
              fullWidth
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
              style={{
                margin: '10px 0',
                padding: '0px',
                width: '100%',
                border: '1px solid #ddd',
                borderRadius: '8px',
                outline: 'none',
                fontSize: '16px',
                transition: '0.3s',
                background: themeMode === 'light' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.2)',
                color: themeMode === 'light' ? '#333' : '#fff',
              }}
            />
            <TextField
              label="New Password"
              type="password"
              variant="outlined"
              fullWidth
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              style={{
                margin: '10px 0',
                padding: '0px',
                width: '100%',
                border: '1px solid #ddd',
                borderRadius: '8px',
                outline: 'none',
                fontSize: '16px',
                transition: '0.3s',
                background: themeMode === 'light' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.2)',
                color: themeMode === 'light' ? '#333' : '#fff',
              }}
            />
            <TextField
              label="Confirm Password"
              type="password"
              variant="outlined"
              fullWidth
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              style={{
                margin: '10px 0',
                padding: '0px',
                width: '100%',
                border: '1px solid #ddd',
                borderRadius: '8px',
                outline: 'none',
                fontSize: '16px',
                transition: '0.3s',
                background: themeMode === 'light' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.2)',
                color: themeMode === 'light' ? '#333' : '#fff',
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button
                type="submit"
                disabled={loading}
                style={{
                  padding: '12px 24px',
                  background: themeMode === 'light' ? 'linear-gradient(90deg, #975cd7, #5a8fea)' : 'linear-gradient(90deg, #333, #121212)',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  transition: '0.3s ease',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                }}
              >
                {loading ? 'Resetting...' : 'Reset Password'}
              </Button>
            </div>
          </form>
        </div>
      </Container>

      <div style={{ position: 'absolute', top: '20px', left: '20px' }}>
        <img src="/assets/logo.png" alt="Logo" style={{ width: '50px' }} />
      </div>
      <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
        <IconButton onClick={toggleTheme} style={{ color: '#fff' }}>
          {themeMode === 'light' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
        </IconButton>
      </div>
    </ThemeProvider>
  );
};

export default ResetPassword;

